/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default {
	fetch({ commit }) {
		commit('FETCH_PROPERTY_TYPES')
		return new Promise((resolve, reject) => {
			axios.get("/api/property-types/list")
				.then((response) => {
					console.log('set property types');
					commit('SET_PROPERTY_TYPES', response.data)
					resolve(response)
				})
				.catch((error) => { reject(error) })
		})
	},
	save({ commit }, item) {
		return new Promise((resolve, reject) => {
			axios.post('/api/property-types/create', item)
				.then((response) => {
					resolve(response)
				})
				.catch((error) => { reject(error) })
		})
	},
	update({ commit }, item) {
		return new Promise((resolve, reject) => {
			axios.post('/api/property-types/update/' + item.id, item)
				.then((response) => {
					resolve(response)
				})
				.catch((error) => { reject(error) })
		})
	},
	delete({ commit }, id) {
		return new Promise((resolve, reject) => {
			axios.delete(`/api/property-types/delete/${id}`)
				.then((response) => {
					resolve(response)
				})
				.catch((error) => { reject(error) })
		})
	},
}
